import { render, staticRenderFns } from "./AbiturientLayoutView.vue?vue&type=template&id=fe2059ba"
import script from "./AbiturientLayoutView.vue?vue&type=script&lang=js"
export * from "./AbiturientLayoutView.vue?vue&type=script&lang=js"
import style0 from "./AbiturientLayoutView.vue?vue&type=style&index=0&id=fe2059ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports